import { VoucherApi } from '@/api/voucher'

const state = () => ({
    promotionNotifications: [],
    promotionNotificationsPagination: {
        page: 1,
        perPage: 10,
        total: 0,
        from: 1,
    },
    promotionNotification: null,
    isLoadingPromotionNotification: false,
    isSuccessPromotionNotification: true,
    messagePromotionNotification: '',
})

const getters = {
    promotionNotificationsList: state => state.promotionNotifications,
    promotionNotificationsPagination: state => state.promotionNotificationsPagination,
    promotionNotificationDetail: state => state.promotionNotification,
    isLoadingPromotionNotification: state => state.isLoadingPromotionNotification,
    isSuccessPromotionNotification: state => state.isSuccessPromotionNotification,
    messagePromotionNotification: state => state.messagePromotionNotification,
}

const actions = {
    async fetchPromotionNotifications({ commit }) {
        commit('setLoadingPromotionNotification', true)
        await VoucherApi.getAllPromotionNotification()
            .then(response => {
                commit('setPromotionNotifications', response.data.data)
                const pagination = {
                    page: response.data.pages.current_page,
                    perPage: response.data.pages.per_page,
                    total: response.data.pages.total,
                    from: response.data.pages.from,
                }
                commit('setSuccessPromotionNotification', true)
                commit('setPromotionNotificationsPagination', pagination)
                commit('setLoadingPromotionNotification', false)
            })
            .catch(error => {
                console.log(error)
                commit('setSuccessPromotionNotification', false)
                commit('setMessagePromotionNotification', error)
                commit('setLoadingPromotionNotification', false)
            })
    },
    async deletePromotionNotification({ commit }, id) {
        await VoucherApi.removePromotionNotification(id)
            .then(res => {
                if (res.data.success) {
                    commit('setSuccessPromotionNotification', true)
                    commit('setMessagePromotionNotification', 'Berhasil Menghapus Notifikasi Promo')
                } else {
                    commit('setSuccessPromotionNotification', false)
                    commit('setMessagePromotionNotification', 'Terjadi Kesalahan')
                }
            })
            .catch(error => {
                commit('setMessagePromotionNotification', error)
                commit('setSuccessPromotionNotification', false)
            })
    },
    async fetchDetailPromotionNotification({ commit }, id) {
        commit('setLoadingPromotionNotification', true)
        await VoucherApi.detailPromotionNotification(id)
            .then(res => {
                commit('setLoadingPromotionNotification', false)
                commit('setPromotionNotificationDetail', res.data.data)
                commit('setSuccessPromotionNotification', true)
            })
            .catch(error => {
                commit('setLoadingPromotionNotification', false)
                commit('setMessagePromotionNotification', error)
                commit('setSuccessPromotionNotification', false)
            })
    },
    async addPromotionNotification({ commit }, payload) {
        await VoucherApi.addPromotionNotification(payload)
            .then(res => {
                if (res.data.success) {
                    commit('setSuccessPromotionNotification', true)
                    commit('setMessagePromotionNotification', 'Berhasil Tambah Notifikasi Promo')
                } else {
                    commit('setSuccessPromotionNotification', false)
                    commit('setMessagePromotionNotification', 'Terjadi Kesalahan')
                }
            })
            .catch(error => {
                commit('setSuccessPromotionNotification', false)
                commit('setMessagePromotionNotification', error)
            })
    },
    async updatePromotionNotification({ commit }, data) {
        const id = data.id
        const payload = data.payload
        await VoucherApi.updatePromotionNotification(id, payload)
            .then(res => {
                if (res.data.success) {
                    commit('setSuccessPromotionNotification', true)
                    commit('setMessagePromotionNotification', 'Berhasil Update Notifikasi Promo')
                } else {
                    commit('setSuccessPromotionNotification', false)
                    commit('setMessagePromotionNotification', 'Terjadi Kesalahan')
                }
            })
            .catch(error => {
                commit('setSuccessPromotionNotification', false)
                commit('setMessagePromotionNotification', error)
            })
    }
}

const mutations = {
    setPromotionNotifications: (state, promotionNotifications) => {
        state.promotionNotifications = promotionNotifications
    },

    setPromotionNotificationsPagination: (state, promotionNotificationsPagination) => {
        state.promotionNotificationsPagination = promotionNotificationsPagination
    },

    setPromotionNotificationDetail: (state, promotionNotification) => {
        state.promotionNotification = promotionNotification
    },

    setLoadingPromotionNotification: (state, isLoading) => {
        state.isLoadingPromotionNotification = isLoading
    },

    setSuccessPromotionNotification: (state, isSuccess) => {
        state.isSuccessPromotionNotification = isSuccess
    },

    setMessagePromotionNotification: (state, message) => {
        state.messagePromotionNotification = message
    },
}

export default {
    state,
    getters,
    actions,
    mutations
}